/** @format */

import * as React from "react";
import {
  Flex,
  Text,
  useMediaQuery,
  Stack,
  Button,
  Center,
  Link
} from "@chakra-ui/react";
import { commonInfo } from "@common/index";
import colors from "@src/style/colors";
import style from "./style.module.css";
import theme from "@src/style/theme";

export const Into_KR: React.FC = () => {
  const [isXS, isSmall] = useMediaQuery([
    `(max-width: ${theme.breakpoints.sm})`,
    `(max-width: ${theme.breakpoints.md})`
  ]);
  const basePaddingX = {
    base: "20px",
    sm: "20px",
    md: "65px",
    lg: "108px"
  };
  const basePaddingT = { base: "20px", md: "45px", lg: "45px" };
  const basePaddingB = { base: "44px", sm: "72px", md: "56px", lg: "120px" };

  return (
    <Flex
      position={"static"}
      flexDirection={"row"}
      justifyContent={"center"}
      alignItems={"center"}
      width={"100%"}
      bgColor={colors.white}
      paddingX={basePaddingX}
      pt={basePaddingT}
      pb={basePaddingB}
    >
      <Flex
        maxWidth={theme.breakpoints.mx}
        width={"100%"}
        direction={{ base: "column-reverse", md: "row" }}
        justifyContent={"space-between"}
        alignItems={"center"}
        backgroundColor={colors.white}
      >
        <Flex
          flexGrow={1}
          direction={"column"}
          justifyContent={"flex-start"}
          alignItems={isSmall ? "center" : "start"}
          mt={isSmall ? "40px" : "0px"}
        >
          <Stack
            fontSize={{
              base: "24px",
              sm: "32px",
              md: "35px",
              lg: "44px"
            }}
            fontWeight={"700"}
            textAlign={isSmall ? "center" : "start"}
            gap={"10px"}
          >
            <Text color={colors.black} wordBreak={"keep-all"}>
              디지털 자산에 필요한
              <br />
              새로운 WEB 3.0 플랫폼
            </Text>
          </Stack>
          <Stack
            pt={{
              base: "20px",
              sm: "40px",
              md: "20px",
              lg: "50px",
              xl: "50px"
            }}
            textAlign={isSmall ? "center" : "start"}
            fontSize={{
              base: "16px",
              sm: "18px",
              md: "16px",
              lg: "24px",
              xl: "28px"
            }}
          >
            <Text fontWeight={500} color={colors.black} wordBreak={"keep-all"}>
              샌드뱅크는 기존에 없던
              <br />
              편리한 디지털 자산 관리 경험을 선사합니다
            </Text>
          </Stack>
          <Stack
            pt={{
              base: "32px",
              sm: "50px",
              md: "30px",
              lg: "80px",
              xl: "80px"
            }}
            direction={"row"}
            spacing={"16px"}
          >
            <Link href={commonInfo.appDownload.items[1].url} isExternal>
              <Button
                width={isXS ? "120px" : "165px"}
                height={isXS ? "44px" : "60px"}
                bgGradient="linear(to-tl,#01F6FF, #007BFF)"
                borderRadius={"8px"}
                style={{ transition: "opacity 0.3s" }}
                _hover={{ opacity: "0.5" }}
              >
                <Text
                  color={colors.white}
                  wordBreak={"keep-all"}
                  fontSize={{ base: "12px", sm: "16px" }}
                  fontWeight={"600"}
                >
                  iOS 다운로드
                </Text>
              </Button>
            </Link>
            <Link href={commonInfo.appDownload.items[0].url} isExternal>
              <Button
                width={isXS ? "120px" : "165px"}
                height={isXS ? "44px" : "60px"}
                bgGradient="linear(to-tl,#01F6FF, #007BFF)"
                borderRadius={"8px"}
                style={{ transition: "opacity 0.3s" }}
                _hover={{ opacity: "0.5" }}
              >
                <Text
                  color={colors.white}
                  wordBreak={"keep-all"}
                  fontSize={{ base: "12px", sm: "16px" }}
                  fontWeight={"600"}
                >
                  Android 다운로드
                </Text>
              </Button>
            </Link>
          </Stack>
        </Flex>
        <Center
          width={{
            base: "100%",
            sm: "400px",
            md: "400px",
            lg: "540px",
            xl: "680px"
          }}
        >
          <div className={style.image_box}>
            <video autoPlay loop muted playsInline>
              <source src={commonInfo.intro.video.intro} type="video/mp4" />
            </video>
          </div>
        </Center>
      </Flex>
    </Flex>
  );
};

export default Into_KR;
